export default __webpack_public_path__ + "static/media/satellite.be2b3876.svg";